import * as React from "react";

export type WrapLoading<T> = (proc: () => Promise<T>) => Promise<T>;
export const useLoading = <T>(
  initial: boolean = false,
): [boolean, WrapLoading<T>] => {
  const [isLoading, setIsLoading] = React.useState(initial);
  const wrap = React.useCallback(async (proc: () => Promise<T>) => {
    setIsLoading(true);
    try {
      return await proc();
    } finally {
      setIsLoading(false);
    }
  }, []);
  return [isLoading, wrap];
};
